import React from 'react'
import styles from './closeButton.module.css'
import { FaTimesCircle } from 'react-icons/fa'

type CloseIconProps = {
  className: string
  clickHandler: () => void
}

const CloseIcon: React.FC<CloseIconProps> = ({ className, clickHandler }) => {
  return (
    <div className={className} onClick={clickHandler}>
      <FaTimesCircle className={styles.closeIcon} />
    </div>
  )
}

export default CloseIcon
